import { Parser } from '@json2csv/plainjs';

function snakeToCamel(str: string): string {
	return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
}

function camelToSnake(str: string): string {
	return str.replace(/([A-Z])/g, '_$1').toLowerCase();
}

export type JsonValue =
	| string
	| number
	| boolean
	| null
	| JsonValue[]
	| { [key: string]: JsonValue };

function transformKeysSnakeToCamelCase(data: JsonValue): JsonValue {
	if (data === null) return null;

	if (typeof data !== 'object') return data;

	// Handle arrays
	if (Array.isArray(data)) {
		return data.map((item) => transformKeysSnakeToCamelCase(item));
	}

	// Handle objects
	const result: Record<string, JsonValue> = {};

	for (const key in data) {
		if (Object.prototype.hasOwnProperty.call(data, key)) {
			const camelKey = snakeToCamel(key);
			result[camelKey] = transformKeysSnakeToCamelCase(data[key] as JsonValue);
		}
	}

	return result;
}

function transformKeysCamelToSnakeCase(data: JsonValue): JsonValue {
	if (data === null) return null;

	if (typeof data !== 'object') return data;

	// Handle arrays
	if (Array.isArray(data)) {
		return data.map((item) => transformKeysCamelToSnakeCase(item));
	}

	// Handle objects
	const result: Record<string, JsonValue> = {};

	for (const key in data) {
		if (Object.prototype.hasOwnProperty.call(data, key)) {
			const snakeKey = camelToSnake(key);
			result[snakeKey] = transformKeysCamelToSnakeCase(data[key] as JsonValue);
		}
	}

	return result;
}

function chunkArray(array: unknown[], size: number) {
	return Array.from({ length: Math.ceil(array.length / size) }, (_, i) =>
		array.slice(i * size, (i + 1) * size)
	);
}

function capitalizeString(str: string = '') {
	try {
		str = str.toLocaleLowerCase();
		return str
			.split(' ')
			.map((e) => e.charAt(0).toUpperCase() + e.slice(1))
			.join(' ');
	} catch (e) {
		console.error('Error in capitalizeString', e);
		return str;
	}
}

function parseJsonToCsv(data: Record<string, string>[]): string {
	try {
		const parser = new Parser();
		const csv = parser.parse(data);
		return csv;
	} catch (err) {
		console.error(err);
		return '';
	}
}

export {
	transformKeysSnakeToCamelCase,
	transformKeysCamelToSnakeCase,
	snakeToCamel,
	chunkArray,
	capitalizeString,
	parseJsonToCsv,
};
